import { fetchWithHandling } from "../../utils/ApiUtils";


const BASE_URL = process.env.REACT_APP_BASE_URL || 'http://localhost:8080/api/';


//get notifications
export async function getTopTenNotifications() {
    return await fetchWithHandling(`${BASE_URL}notifications/top-ten`, {
        credentials: 'include'
    });
}

// fetch pageable notifications { page, size }
export async function getNotificationsPage(page = 0, size = 10) {
    const url = `${BASE_URL}notifications?page=${page}&size=${size}`

    return await fetchWithHandling(url, { credentials: 'include' });
}

    //Get Notification
export const getNotification = async (notificationId) => {
    return await fetchWithHandling(`${BASE_URL}notifications/${notificationId}`, {
        credentials: 'include'
    });
    
}

//Update notification to read
export const updateNotificationToRead = async (notificationId) => {
    return await fetchWithHandling(`${BASE_URL}notifications/${notificationId}/update-to-read`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include'
    });
}